import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19607610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import {computed, ref} from "vue";
import SweetTransitions from "@/components/AnimationsSweetTransitionsMain.vue";
import BallAnimation from "@/components/AnimationsBallAnimationMain.vue";
import ClassAnimation from "@/components/AnimationsClassAnimation.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const active = ref('');

const selectedComponent = computed(() => {
  if (active.value === 'ball') return BallAnimation;
  if (active.value === 'class') return ClassAnimation;
  if (active.value === 'sweet') return SweetTransitions;
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (active.value !== 'ball' ? active.value = 'ball' : active.value=''))
      }, "Ball animation with transition component"),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (active.value !== 'class' ? active.value = 'class' : active.value = ''))
      }, "Animations just using CSS"),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (active.value !== 'sweet' ? active.value = 'sweet' : active.value = ''))
      }, "Sweet Transition using vue specific transition tags"),
      _createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (active.value !== 'js' ? active.value = 'js' : active.value = ''))
      }, "Javascript")
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(selectedComponent)))),
    (active.value === 'js')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " JavaScript animations are best done with libraries like greensock. However, the really cool packages are not available for free and therefore the animation in this repo is not working. "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})